<template>
     <el-dialog
    :visible="true"
    :title="$t('popper_title.add_fmilies_nickname')"
    custom-class="codelab-popper codelab-add-family-nickname"
    :show-close="false"
    :append-to-body="true"
    :before-close="close"
    width="400px"
    >
        <el-form class="codelab-form" ref="ruleForm" :rules="rules" :model="ruleForm" @submit.native.prevent="confirm">
            <el-form-item prop="name">
                <el-input ref="input" v-model="ruleForm.name" :placeholder="$t('placeholder.input_family_nckname')" tabindex="1" :maxlength="12"></el-input>
            </el-form-item>
        </el-form>
        <p class="nickname-discription">{{$t("add_families_nickname_discription")}}</p>
        <div slot="footer">
            <span class="popper-footer-button codelab-button gray" @click="close" tabindex="3">{{$t("button.cancel")}}</span>
            <span class="popper-footer-button codelab-button blue" @click="confirm" :class="{'disabled': !nickNameValidated}" tabindex="2">{{$t("button.add")}}</span>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
export default {
    name: "add-families",
    props: {
        visible: Boolean
    },
    data() {
        return {
            nickNameValidated: false,
            ruleForm: {
                name: ""
            },
            rules: {
                name: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                this.nickNameValidated = false
                                callback(this.$t("placeholder.input_family_nckname"))
                                return
                            }
                            
                            if (new RegExp(this.regularVer).test(value)) {
                                this.nickNameValidated = false
                                callback(this.$t("message.error_project_name")) // error_family_nickname
                            } else if([...this.tempFamilies, ...this.usedFamilies].find(item => item.label === value)){
                                this.nickNameValidated = false
                                callback(this.$t("message.error_family_nickname_repeat"))
                            } else {
                                this.nickNameValidated = true
                                callback()
                            }
                        }
                    }
                ],
            }
        }
    },
    computed: {
        ...mapState([
            "usedFamilies",
            "tempFamilies",
            "regularVer"
        ])
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.input && this.$refs.input.focus();
        });
    },
    methods: {
        confirm(){
            this.$refs.ruleForm.validate(async validate => {
                this.nickNameValidated = !!validate;
                if(this.nickNameValidated){
                    let tempFamilies = this.tempFamilies.slice(0);
                    tempFamilies.unshift({
                        value: this.ruleForm.name,
                        label: this.ruleForm.name
                    });
                    this.$store.commit("SET_TEMP_FAMILIES", tempFamilies);
                    this.close();
                    
                }
            });
        },
        close(){
            this.$emit("update:visible", false);
        }
    },
}
</script>
<style lang="scss">
    .codelab-add-family-nickname{
        &.el-dialog.codelab-popper .el-dialog__body{
            padding: 24px 50px 24px 50px;
        }
        .nickname-discription{
            font-size: 14px;
            color: #ffffff;
            line-height: 1.75em;
            margin-top: 24px;
        }
    }
</style>